export default "__VITE_ASSET__CdVxssgW__"